import React from "react";
import BaseHeader from "../Common/BaseHeader";

const Header = ({ company, otherDetails, children }) => {
  return (
    <BaseHeader
      title='Content Page'
      companyName={company.name}
      uen={company.uen}
      yearOfAssessment={otherDetails.yearOfAssessment}
      financialYearStart={otherDetails.financialYearStart}
      financialYearEnd={otherDetails.financialYearEnd}
      companyType={company.companyType || "common"}
      actions={children}
    />
  );
};

export default React.memo(Header);
